<template>
  <section class="select-box">
    <div class="btn-box">
      <!-- <img v-for="(btn, b_index) in chooseBtn" :key="b_index" src="../assets/images/webSelect_0.png" class="img"/> -->
      <img
        v-for="(btn, b_index) in chooseBtn"
        :key="b_index"
        :class="['img-btn']"
        :src="
          chooseState == b_index
            ? imgUrl(b_index, true)
            : imgUrl(b_index, false)
        "
        @click="changeBtn(b_index)"
      />
    </div>
    <threeView v-show="chooseState == 0"></threeView>
    <qjView v-show="chooseState == 1"></qjView>
    <xgtView v-show="chooseState == 2"></xgtView>
  </section>
</template>

<script>
import threeView from "./select/three.vue";
import qjView from "./select/qj.vue";
import xgtView from "./select/xgt.vue";
export default {
  data() {
    return {
      chooseBtn: ["3d", "360", "xgt"],
      chooseState: null,
      url:null,
    };
  },

  components: {
    qjView,
    xgtView,
    threeView,
  },
  created(){
    let sendUrl = window.location.href
    let arr = sendUrl.split('=')
    this.chooseState = arr[1]
  },

  methods: {
    changeBtn(n) {
      this.chooseState == (this.chooseState = n);
    },
    imgUrl(n, state) {
      // 动态添加图片必须使用require
      return state ? require(`../assets/images/webSelect_${n}_${n}.png`) : require(`../assets/images/webSelect_${n}.png`)
    },
  },
};
</script>
<style lang='scss' scoped>
.select-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  // background-color: rgba(130, 130, 130, 0.05);
  // backdrop-filter: blur(5px);
  // background: rgba($color: #000000, $alpha: 1.0);
  // background-image: url(https://images.jianshankeji.com/huxing1.png);
  .btn-box {
    display: flex;
    flex-wrap: wrap;
    width: 100px;
    position: fixed;
    bottom: 25px;
    left: 40px;
    z-index: 5;
    .img-btn{
      width: 90px;
      height: 30px;
      margin-bottom: 5px;
    }
  }
}
</style>